import type { EbookQuestion } from '@wx-weiqi/contracts';

type ChapterBook = { questionIds: string[]; chapters?: string[] | undefined };
type ChapterQuestion = Pick<EbookQuestion, 'id' | 'chapter'>;

/** Legacy import labels represent the same unassigned chapter, not real chapters. */
export function normalizeEbookChapter(value: string | null | undefined): string {
  const name = value?.trim() ?? '';
  return name === '未分章' || name === '未分配章节' ? '' : name;
}

/** Explicit directory order first; older question-only chapter names follow book order. */
export function ebookChapterNames(book: ChapterBook, questions: ChapterQuestion[]): string[] {
  const byId = new Map(questions.map((question) => [question.id, question]));
  const names = [
    ...(book.chapters ?? []),
    ...book.questionIds.map((id) => byId.get(id)?.chapter ?? ''),
  ];
  return [...new Set(names.map(normalizeEbookChapter).filter(Boolean))];
}

/** null means the whole book; an empty string means unassigned, including missing metadata. */
export function ebookChapterQuestionIds(
  book: ChapterBook,
  questions: ChapterQuestion[],
  chapter: string | null,
): string[] {
  if (chapter === null) return book.questionIds;
  const normalized = normalizeEbookChapter(chapter);
  const byId = new Map(questions.map((question) => [question.id, question]));
  return book.questionIds.filter(
    (id) => normalizeEbookChapter(byId.get(id)?.chapter) === normalized,
  );
}
